import { module } from './store'
import { createModule } from '@vue-storefront/core/lib/module'

export const KEY = 'languages'
export const Languages = createModule({
  key: KEY,
  store: { modules: [{ key: KEY, module }] }
})
